/* stylelint-disable order/properties-order */

import styled from 'styled-components';

import { Button } from '@/core/components/Button';
import {
  BodyMedium,
} from '@/core/components/Typography/Typography.styles';

import { breakpoint } from '@/themes/breakpoints';

export const RowContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;

  @media ${breakpoint.sm} {
    flex-direction: row;
  }
`;

export const InputContainer = styled.div`
  margin-top: 16px;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  padding: 40px 16px 80px 16px;
  background-image: url("/assets/images/eagle.png");
  background-position: right 165px;
  background-repeat: no-repeat;

  @media ${breakpoint.sm} {
    padding: 80px 80px 160px 80px;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 860px;
`;

export const StyledButton = styled(Button)`
  box-sizing: content-box;
  align-self: end;
  margin-top: 24px;

  @media ${breakpoint.sm} {
    margin-top: 32px;
  }
`;

export const ErrorBar = styled.div`
  ${BodyMedium}
  z-index: 1;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 10px;
  background: ${({ theme }) => theme.colors.semantic.danger[500]};
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
`;
